import {
	createFileRoute,
	Outlet,
	useParams,
	useRouterState,
} from "@tanstack/react-router";
import { TicketWorkspaceAssetsTable } from "@/features/tickets/components/ticket-workspace-assets-table";
import { isNestedAssetWorkspacePath } from "@/features/tickets/lib/is-nested-asset-workspace-path.util";

export const Route = createFileRoute(
	"/_authenticated/(web-app)/_web/web/$orgId/tickets/(ticket)/$ticketId/workspace/assets",
)({
	component: TicketWorkspaceAssetsTab,
	validateSearch: (search: Record<string, unknown>) => ({
		q: typeof search.q === "string" ? search.q : undefined,
	}),
});

/**
 * Job workspace Assets tab — table shell with outlet for asset drawer / nested workspace.
 */
function TicketWorkspaceAssetsTab() {
	const params = useParams({
		from: "/_authenticated/(web-app)/_web/web/$orgId/tickets/(ticket)/$ticketId/workspace/assets",
	});
	const pathname = useRouterState({
		select: (state) => state.location.pathname,
	});

	if (isNestedAssetWorkspacePath(pathname)) {
		return <Outlet />;
	}

	return (
		<div className="relative flex min-h-0 w-full flex-1 flex-col">
			<TicketWorkspaceAssetsTable
				orgId={params.orgId}
				ticketId={params.ticketId}
			/>
			<Outlet />
		</div>
	);
}
